import * as adminAction from "../actions/adminCommonAction";
import { call, put, takeLatest } from "redux-saga/effects";
import { apiError } from "../../utils/helper";
import {
  addOshaToken,
  getDropdownDataKeyValue,
  getInspections,
  getOshaTokenDetails,
  getSupervisorByProject,
} from "../../services/adminCommonService";
import {
  getDropdownDataKeyValueType,
  getInspectionsType,
  getSupervisorByProjectType,
  thirdPartyApiType,
} from "../constants/adminCommonType";

export function* getInspectionsSaga(params) {
  try {
    const { data, status, error } = yield call(getInspections, params);
    if (!data && status !== 200) throw apiError(error);
    const page = getInspectionsType.CONTACT_PAGE;
    yield put(
      adminAction.getInspectionstSuccess({
        page,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Inspection Failed" };
    yield put(adminAction.getInspectionstSuccess(data));
  }
}

export function* getDropdownDataKeyValueSaga(params) {
  console.debug("contactListSaga");
  try {
    const { data, status, error } = yield call(getDropdownDataKeyValue, params);
    if (!data && status !== 200) throw apiError(error);
    const page = getInspectionsType.CONTACT_PAGE;
    yield put(
      adminAction.getDropdownDataKeyValueSuccess({
        page,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Inspection Failed" };
    yield put(adminAction.getDropdownDataKeyValueSuccess(data));
  }
}

export function* getSupervisorByProjectSaga(params) {
  console.debug("supervisorByProjectSaga");
  try {
    const { data, status, error } = yield call(getSupervisorByProject, params);
    if (!data && status !== 200) throw apiError(error);
    const page = getSupervisorByProjectType.SUPERVISOR_BY_PROJECT_PAGE;
    yield put(
      adminAction.getSupervisorByProjectSuccess({
        page,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Supervisor By Project Failed" };
    yield put(adminAction.getSupervisorByProjectFailure(data));
  }
}

export function* addOshaTokenSaga(params) {
  try {
    const { data, status, error } = yield call(addOshaToken, params);
    if (!data && status !== 200) throw apiError(error);
    yield put(
      adminAction.addOshaTokenSuccess({
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Post osha token Failed" };
    yield put(adminAction.addOshaTokenFailure(data));
  }
}

export function* getOshaTokenDetailsSaga(params) {
  try {
    const { data, status, error } = yield call(getOshaTokenDetails, params);
    if (!data && status !== 200) throw apiError(error);
    const page = thirdPartyApiType.GET_OSHA_TOKEN_DETAILS_PAGE;
    yield put(
      adminAction.getOshaTokenDetailsSuccess({
        page,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "get Osha Token Details Failed" };
    yield put(adminAction.getOshaTokenDetailsFailure(data));
  }
}

const myAdminSaga = [
  takeLatest(getInspectionsType.GET_INSPECTION_PENDING, getInspectionsSaga),
  takeLatest(
    getDropdownDataKeyValueType.GET_DROPDOWN_DATA_KEY_VALUE_PENDING,
    getDropdownDataKeyValueSaga
  ),
  takeLatest(
    getSupervisorByProjectType.GET_SUPERVISOR_BY_PROJECT_PENDING,
    getSupervisorByProjectSaga
  ),
  takeLatest(
    thirdPartyApiType.POST_ADD_OSHA_TOKEN_PENDING,
    addOshaTokenSaga
  ),
   takeLatest(
    thirdPartyApiType.GET_GET_OSHA_TOKEN_DETAILS_PENDING,
    getOshaTokenDetailsSaga
  ),
];

export default myAdminSaga;
